import { render, staticRenderFns } from "./PaymentSalaryHistoryList.vue?vue&type=template&id=2c06499d&scoped=true"
import script from "./PaymentSalaryHistoryList.vue?vue&type=script&lang=js"
export * from "./PaymentSalaryHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06499d",
  null
  
)

export default component.exports